module.exports = __webpack_public_path__ + "assets/img/EISS-Super-eBook.ee044b0b.webp";